import * as React from 'react';

import { AgendaViewPage } from '../AgendaViewPage';
import { CalendarPrintPreviewStyles } from './CalendarPrintPreview.types';
import { CalendarViewPage } from '../CalendarViewPage';
import { IClassNames } from '@fluentui/utilities';
import { PrintConfiguration } from '..';
import { isBrowserFirefox } from 'owa-user-agent/lib/userAgent';

let cssStyles = require('./CalendarPrintPreview.scss');
let bindClassNames = require('classnames/bind').bind(cssStyles);

/**
 * Since we no longer have a pivot in the view, this function returns the page to show directly in the print view
 * @param classNames
 * @param props
 */
export function getPivotItems<TEvent>(
    classNames: IClassNames<CalendarPrintPreviewStyles>,
    props: PrintConfiguration<TEvent>
): JSX.Element[] {
    const { title, agenda, weekLayout, notes, calendarColorScheme, miniMonth } = props;
    const {
        calendarView,
        events,
        getSurfaceItemModel,
        getCalendarEventColorScheme,
        getCharm,
        getDetailedEvent,
        isRTL,
    } = props;

    const isFirefox = isBrowserFirefox();
    let viewPageStyle = isFirefox ? classNames.ffprintPage : {};

    if (agenda) {
        return [
            <div
                key="calendarView"
                id="calendarPrintableItem"
                className={isFirefox ? undefined : classNames.printWrapper}>
                <AgendaViewPage
                    className={bindClassNames(
                        classNames.printPage,
                        cssStyles.scrollingPrintPage,
                        cssStyles.agendaScrollingPrintPage
                    )}
                    calendarView={calendarView}
                    events={events}
                    preview={true}
                    title={title}
                    calendarColorScheme={calendarColorScheme}
                    miniMonth={miniMonth}
                    getDetailedEvent={getDetailedEvent}
                />
            </div>,
        ];
    }

    return [
        <div
            key="calendarView"
            id="calendarPrintableItem"
            className={isFirefox ? undefined : classNames.printWrapper}>
            <CalendarViewPage
                className={bindClassNames(classNames.printPage, cssStyles.preview, viewPageStyle)}
                calendarView={calendarView}
                events={events}
                getSurfaceItemModel={getSurfaceItemModel}
                getCalendarEventColorScheme={getCalendarEventColorScheme}
                getCharm={getCharm}
                notes={notes}
                title={title}
                weekLayout={weekLayout}
                calendarColorScheme={calendarColorScheme}
                miniMonth={miniMonth}
                isRTL={isRTL}
            />
        </div>,
    ];
}
